module.exports = __webpack_public_path__ + "static/media/wizardIntoPigeon.2bc45f7f.gif";